<div class="content">
    <div class="title bold">
        <span>{{ "GENERAL.LAST_MEMBRANE_CHANGE" | translate}}</span>
    </div>
    <a class="contact"
        [href]="'https://www.gea.com/en/contact/?cu=contact-us-get-a-quote&pgid=%7B350D55E8-D8FC-4AA6-B62E-0CBA0B3505C6%7D&su=https://www.gea.com/en/products/membrane-filtration&utm_source=smartfiltration'"
        target="_blank" rel="noopener noreferrer">
        <mat-icon aria-hidden="false" aria-label="concat" class="icon">call</mat-icon>
        <span class="">{{ "GENERAL.CONTACT" | translate}}</span>
    </a>
    <div class="row">
        <span>{{ "GENERAL.LAST_CHANGE" | translate}}</span>
        <span class="bold">{{lastChange}}</span>
    </div>
    <div class="row">
        <span>{{ "GENERAL.SINCE_CHANGE" | translate}}</span>
        <span class="bold" *ngIf="sincePeriod=='Weeks'"> {{sinceChange}} {{"GENERAL.WEEKS" | translate }} </span>
        <span class="bold" *ngIf="sincePeriod=='Days'"> {{sinceChange}} {{"GENERAL.DAYS" | translate }} </span>
    </div>
    <div class="row">
        <span>{{ "GENERAL.NUMBER_OF_CIP_CHANGE" | translate}}</span>
        <span class="bold">{{cips}} {{'GENERAL.CIP' | translate}}s</span>
    </div>
</div>
